@if (isAuthorized) {
  <router-outlet></router-outlet>
}
